import { InputArchivoEndosoMasivo } from "../models/inputArchivoEndosoMasivo";
import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { RowRecaudacionEndosoMasivo } from "../models/rowRecaudacionEndosoMasivo";
import { ResultadoRecaudacionEndoso } from "../models/resultadoRecaudacionEndoso";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";

const enviarExcelEndosoMasivo = async (e: InputArchivoEndosoMasivo) => {
    const formData = new FormData();
    formData.append("origen", e.origen);
    formData.append("formaPago", e.formaPago);
    formData.append("archivo", e.archivo);
    const response: Promise<any> = axiosInstance.post(`siscred-api-cartera-total/v1/endosos/cargararchivomasivo`, formData,
        {
            headers: {
                'X-Hide-Toast': 'true',
            }
        }
    );
    return response;
}

const recaudarEndososMasivos = async (e: RowRecaudacionEndosoMasivo[]) => {
    const items = {
        items: e
    }
    const response: Promise<AxiosResponse<ListResponseDto<ResultadoRecaudacionEndoso>>> = axiosInstance.post(`siscred-api-cartera-total/v1/endosos/recaudarendoso`, items);
    return response;
}

export { enviarExcelEndosoMasivo, recaudarEndososMasivos }